<template>
  <div class="h-full w-full flex items-center">
    <portal to="mobile-header">
      Conversations
    </portal>
    <div class="bg-gray-50 overflow-hidden rounded-lg mx-auto">
      <div class="px-4 py-5 sm:p-6">
        No conversation selected
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
